export const selectRotaOptions = state => state.rotaSchedule.options;
export const selectRotaDetail = state => state.rotaSchedule.detail;
export const selectRotaWrite = state => state.rotaSchedule.write;
export const selectCanManageRota = state => ['ADMIN', 'MANAGER'].includes(String(state.auth.user?.role?.name || state.auth.user?.role || '').toUpperCase());
